export const transformBlobToUrl = async (logoBlob: Blob) => {
    const arrayBuffer = await logoBlob.arrayBuffer()

    const logoBase64 = Buffer.from(arrayBuffer).toString("base64")

    return `data:image/png;base64,${logoBase64}`
}
